"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "ProductListSkeleton", {
  enumerable: true,
  get: function () {
    return _ProductListContainerSkeleton.ProductListContainerSkeleton;
  }
});
var _ProductListContainerSkeleton = require("./ProductListContainerSkeleton");
